import { createApp } from "vue";
import Browser from "./components/Browser.vue";
import { initMenu } from "./components/Menu.js";
//import StickySidebar from 'sticky-sidebar'
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./style.css";
import "./assets/swipe.svg";

createApp(Browser).mount("#browser");
initMenu();

/*document.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia("(min-width: 901px)").matches) {
    console.log(223)
    window.sidebar = new StickySidebar('.sidebar', {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: 'body>.container',
      innerWrapperSelector: '.sidebar__inner'
    });
  }
});*/

document.querySelectorAll(".newspapper-teaser").forEach((el) => {
  el.addEventListener("click", () => {
    window.showBrowser(el.dataset.id);
  });
});

new Swiper(".swiper-container--books .swiper-container", {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 15,
  //autoHeight : true,
  breakpoints: {
    320: {
      slidesPerView: 2
    }, 480: {
      slidesPerView: 2
    }, 940: {
      slidesPerView: 3
    }
  },
  paginationOFF: {
    el: ".swiper-pagination",
    type: "progressbar"
  },
  navigation: {
    nextEl: ".swiper-container--books .swiper-button-next",
    prevEl: ".swiper-container--books .swiper-button-prev"
  },
  scrollbar: {
    //el: '.swiper-scrollbar',
  }
});

new Swiper(".swiper-container--news .swiper-container", {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 15,
  //autoHeight : true,
  breakpoints: {
    320: {
      slidesPerView: 2
    }, 480: {
      slidesPerView: 2
    }, 940: {
      slidesPerView: 3
    }, 1200: {
      slidesPerView: 3
    }
  },
  paginationOFF: {
    el: ".swiper-pagination",
    type: "progressbar"
  },
  navigation: {
    nextEl: ".swiper-container--news .swiper-button-next",
    prevEl: ".swiper-container--news .swiper-button-prev"
  },
  scrollbar: {
    //el: '.swiper-scrollbar',
  }
});
